import logoVideo from "../../asset/Home/AI_LOGO.mp4";
import lines from "../../asset/Home/lines.svg";
import redCircle from "../../asset/Home/redCircle.svg";
import yellowCircle from "../../asset/Home/yellowCircle.svg";
import rightLine from "../../asset/Home/rightline.svg";
import { Typewriter } from "react-simple-typewriter";
// import { useNavigate } from "react-router-dom";

function Hero() {
  // const navigate = useNavigate();
  const scrollToSection = (id) => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  return (
    <section className="w-full overflow-hidden">
      {/* ================= HERO ================= */}
      <div className="px-3 sm:px-4 md:px-6 lg:px-8">
        <div
          className="
						relative
						overflow-hidden
						bg-[#F8F5F5]
						rounded-[20px]
						w-full
            max-w-full

            h-[420px]
            sm:h-[500px]
            md:h-[600px]
            lg:h-[650px]
            xl:h-[700px]
						flex
						items-center
						justify-center
					"
        >
          {/* Left Circle */}
          <img
            src={redCircle}
            alt=""
            className="
							absolute
							top-[-5%]
							left-[-15%]
							w-[240px]
              sm:w-[350px]
              md:w-[500px]
              lg:w-[700px]
              xl:w-[850px]
							opacity-90
							pointer-events-none
						"
          />

          {/* Right Circle */}
          <img
            src={yellowCircle}
            alt=""
            className="
							absolute
							bottom-[-10%]
							right-[-15%]
							w-[260px]
sm:w-[380px]
md:w-[550px]
lg:w-[800px]
xl:w-[900px]
							opacity-90
							pointer-events-none
						"
          />

          {/* Left Lines */}
          <img
            src={lines}
            alt=""
            className="
							hidden
							md:block
							absolute
							-top-10
							left-0
							w-[550px]
              
							pointer-events-none
						"
          />

          {/* Right Lines */}
          <img
            src={rightLine}
            alt=""
            className="
							hidden
							md:block
							absolute
							top-0
							right-0
							h-full
							w-auto
							opacity-90
							pointer-events-none
						"
          />

          {/* Content */}
          <div
            className="
            relative
            z-10
            w-full
            max-w-[1100px]
            mx-auto
            px-4
            sm:px-6
            lg:px-8
            text-center
            break-words
          "
          >
<h1
  className="
    font-unbounded
    font-bold
    text-[#474340]
    text-[19px]
    md:text-[40px]
    lg:text-[50px]
    xl:text-[60px]
    leading-[1.2]
    text-center
  "
>
  AI that{" "}

  <span
    className="
      inline-block
      bg-[#FFD9D6]
      text-[#E8604A]
      px-3
      py-1
      lg:rounded-xl
      md:rounded-lg
      rounded-md
      min-w-[100px]
      md:min-w-[180px]
      lg:min-w-[220px]
      text-center
    "
  >
    <Typewriter
      words={[
        "Speaks",
        "Sounds",
        "Connects",
        "Sells",
        "Thinks",
        "hustles",
"levels up", 
"stays online ",
"never misses",
"shows up"
      ]}
      loop={0}
      cursor
      cursorStyle="|"
      typeSpeed={90}
      deleteSpeed={90}
      delaySpeed={1800}
    />
  </span>

  {" "}like you
</h1>

            {/* <div className="mt-2">
              <span
                className="
                inline-block
                bg-[#FFD9D6]
                text-[#E8604A]
                font-unbounded
                font-bold
                px-3
                py-2
                rounded-xl
                text-[15px]
                xs:text-[20px]
                sm:text-[30px]
                md:text-[35px]
                lg:text-[40px]
                lg:min-w-[200px]
                min-w-[350px]
                md:min-w-[270px]
              "
              >
                <Typewriter
                  words={[
                    "Speaks",
                    "Sounds",
                    "Connects",
                    "Sells",
                  ]}
                  loop={0}
                  cursor
                  cursorStyle="|"
                  typeSpeed={90}
                  deleteSpeed={90}
                  delaySpeed={1800}
                />
              </span>
            </div> */}

            <p
              className="
								mt-5
								max-w-[700px]
								mx-auto
								text-[#666]
								font-jakarta
								leading-relaxed
								text-[14px]
md:text-[16px]
lg:text-[18px]
							"
            >
              With Craft Your Agent, build AI agents that know your business, sound like your team, and deliver natural conversations 24/7.
            </p>

            <div
              className="
								mt-8
								flex
								flex-col
								md:flex-row
								items-center
								justify-center
								gap-3
							"
            >
              <button
                onClick={() => scrollToSection("agents")}
                className="
    bg-[#E8604A]
    text-white
    font-prompt
    font-semibold

    w-auto
    min-w-[140px]

    h-10
    sm:h-12

    px-8
    md:px-8

    text-[13px]
    sm:text-[16px]

    rounded-md

    hover:bg-[#d95540]
    transition-all
  "
              >
                Launch AI Agent
              </button>

              <button
                onClick={() => scrollToSection("live-demo")}
                className="
    bg-white
    border
    border-gray-200
    font-prompt
    font-semibold

    w-auto
    min-w-[130px]

    h-10
    md:h-12

    px-8
    md:px-6

    text-[13px]
    sm:text-[16px]

    rounded-md
    text-[#46453D]

    flex
    items-center
    justify-center

    gap-2
    sm:gap-3

    hover:shadow-md
    transition-all
  "
              >
                <div
                  className="
      w-7
      h-7
      rounded-full
      overflow-hidden
      shrink-0
    "
                >
                  <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="
        w-full
        h-full
        object-cover
        scale-[1.8]
      "
                  >
                    <source src={logoVideo} type="video/mp4" />
                  </video>
                </div>

                <span>Live Demo</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
